import { useTranslation } from 'react-i18next';
import { More } from '../../assets/icons';
import { useCompanyPermissions } from '../../hooks/useCompanyPermissions';
import { License } from '../../stores/types';
import { Divider, Menu } from '../_ui';
import { AssignLicenseMenuItem } from './menu-actions/AssignLicenseMenuItem';
import { DeleteLicenseMenuItem } from './menu-actions/DeleteLicenseMenuItem';
import { EditLicenseMenuItem } from './menu-actions/EditLicenseMenuItem';
import { RenewLicenseMenuItem } from './menu-actions/RenewLicenseMenuItem';
import { UnassignLicenseMenuItem } from './menu-actions/UnassignLicenseMenuItem';
import { ViewLicenseDetailsMenuItem } from './menu-actions/ViewLicenseDetailsMenuItem';

const SupportLicenseGridMenu = ({ license }: { license: License }) => {
  const { t } = useTranslation();
  const { canEditLicenses, canDeleteLicenses } = useCompanyPermissions(license.companyId);

  // Check if we should show the divider (if at least one action below it is visible)
  const showDivider = canEditLicenses || canDeleteLicenses;

  return (
    <Menu placement='bottom-end' icon={More} iconAlt={t('icon_alt_more_options')}>
      {canEditLicenses && <AssignLicenseMenuItem license={license} />}
      <ViewLicenseDetailsMenuItem license={license} />
      {canEditLicenses && <RenewLicenseMenuItem license={license} />}
      {canEditLicenses && <UnassignLicenseMenuItem license={license} />}
      {showDivider && <Divider className='mx-2' margin='8px' />}
      {canEditLicenses && <EditLicenseMenuItem license={license} />}
      {canDeleteLicenses && <DeleteLicenseMenuItem license={license} />}
    </Menu>
  );
};

export default SupportLicenseGridMenu;
